import React from "react";

import PropTypes from "prop-types";

import "./feature-card.css";

const FeatureCard = (props) => {
  return (
    <div
      style={{ paddingTop: 50 }}
      className={`feature-card-container ${props.rootClassName} `}
    >
      <img
        alt={props.image_alt}
        src={props.image_src}
        className="feature-card-image"
      />
      <h5 className="feature-card-text Headline5">{props.card_title}</h5>
      <span className="feature-card-text1">{props.text}</span>
    </div>
  );
};

FeatureCard.defaultProps = {
  card_title: "Title",
  text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed erat nibh tristique ipsum.",
  image_src: "/01.svg",
  rootClassName: "",
  image_alt: "image",
};

FeatureCard.propTypes = {
  card_title: PropTypes.string,
  text: PropTypes.string,
  image_src: PropTypes.string,
  rootClassName: PropTypes.string,
  image_alt: PropTypes.string,
};

export default FeatureCard;
